var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import useStore from './../store.js';
import i18n from '@pureartisan/simple-i18n';
import { CoreButton, TourIcon } from './../../../core';
import Panel from '../../../core/Panel/Panel.js';
import PanelHeader from '../../../core/Panel/PanelHeader.js';
import PanelBody from '../../../core/Panel/PanelBody.js';
import styled from 'styled-components';
var ContentWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 2rem;\n  h3 {\n    font-size: 1.4rem;\n    margin-top: 2rem;\n    margin-bottom: 1rem;\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n  p {\n    margin-bottom: 1rem;\n  }\n"])));

var PanelInfoView = function PanelInfoView(_ref) {
  var onClose = _ref.onClose,
      props = _objectWithoutPropertiesLoose(_ref, ["onClose"]);

  var activeView = useStore(function (state) {
    return state.activeView;
  });
  var enableTour = useStore(function (state) {
    return state.enableTour;
  });
  var setUpTour = useStore(function (state) {
    return state.setUpTour;
  });
  var incrementLaunchTour = useStore(function (state) {
    return state.incrementLaunchTour;
  });
  var interactionsMobile = useStore(function (state) {
    return state.interactionsMobile;
  });
  /**
   * Close the intro panel and start the tour
   */

  var handleStartTour = function handleStartTour() {
    // console.log('handleStartTour()')
    incrementLaunchTour();
    setUpTour();
  };

  return /*#__PURE__*/React.createElement(Panel, _extends({
    className: "map-panel-slideout-info tour-desk-11"
  }, props), /*#__PURE__*/React.createElement(PanelHeader, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement("h2", {
    className: "gotham18"
  }, i18n.translate('UI_PANEL_INFO_TITLE'))), /*#__PURE__*/React.createElement(PanelBody, null, enableTour && /*#__PURE__*/React.createElement("div", {
    className: "d-flex pb-0 pt-5 px-5"
  }, /*#__PURE__*/React.createElement(CoreButton, {
    className: "p-3 text-nowrap tour-desk-12",
    color: "light",
    label: i18n.translate('UI_MAP_INTRO_MODAL_TOUR_BTN'),
    onClick: handleStartTour
  }, /*#__PURE__*/React.createElement(TourIcon, null), i18n.translate('UI_MAP_INTRO_MODAL_TOUR_BTN')), /*#__PURE__*/React.createElement("p", {
    className: "hint ml-6 mt-0"
  }, i18n.translate('UI_MAP_INTRO_MODAL_TOUR'))), /*#__PURE__*/React.createElement(ContentWrapper, {
    dangerouslySetInnerHTML: {
      __html: i18n.translate('UI_PANEL_INFO_MAP')
    }
  })));
};

export default PanelInfoView;